import router from '../../router'
import axios from "axios/index";

export const user = {
    /*
      Defines the state being monitored for the module.
    */
    state: {
        user: {
            id:         '',
            email:      '',
            name:       '',
            surname:    '',
            is_admin:   0
        },
        userLoadStatus: 0,
        users: [],
    },

    /*
      Defines the actions used to retrieve the data.
    */
    actions: {
        getAllUsers ({commit}) {
            axios.post('api/users/items').then(
              response => {
                  commit('recieve_users', response.data.users)
              }
            ).catch(errors =>{
                console.log(errors);
            })
        },
        loadUser( { commit }){
            commit( 'setUserLoadStatus', 1 );
            axios.post('/check-token', {}).then( function( response ){
                commit( 'setUserLoadStatus', 2 );
                commit( 'setUser', {
                    id:         response.data.id,
                    email:      response.data.email,
                    name:       response.data.name,
                    surname:    response.data.surname,
                    is_admin:   response.data.is_admin
                } );
            }).catch( function(){
                window.localStorage.setItem('user', '');
                window.localStorage.setItem('token', '');
                commit( 'setUser', {} );
                commit( 'setUserLoadStatus', 3 );
                axios.defaults.headers.common = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer null`
                };
                // Vue.swal({
                //     type:   'warning',
                //     title:  'Token sesji wygasł, zaloguj się ponownie.',
                //     showConfirmButton: true,
                // }).then(() => {
                    router.push({name: 'login'});
                // });
            });
        },

        /*
          Logs out a user and clears the status and user pieces of
          state.
        */
        logoutUser( { commit } ){
            commit( 'setUser', {} );
            commit( 'setUserLoadStatus', 0 );
            window.localStorage.setItem('user', '');
            window.localStorage.setItem('token', '');
            axios.defaults.headers.common = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer null`
            };
            Vue.swal({
                type:   'success',
                title:  'Zostałeś poprawnie wylogowany.',
                showConfirmButton: true,
            }).then(() => {
                router.push({name: 'login'});
                // location.reload();
            });
        }
    },

    /*
      Defines the mutations used
    */
    mutations: {
        /*
          Sets the user load status
        */
        setUserLoadStatus( state, status ){
            state.userLoadStatus = status;
        },

        /*
          Sets the user
        */
        setUser( state, user ){
            state.user.id =         user.id;
            state.user.email =      user.email;
            state.user.name =       user.name;
            state.user.surname =    user.surname;
            state.user.is_admin =   user.is_admin;
        },
        recieve_users (state, users) {
            state.users = users;
        },

    },

    /*
      Defines the getters used by the module.
    */
    getters: {

        /*
          Returns the user load status.
        */

        getUserLoadStatus( state ){
            return function(){
                return state.userLoadStatus;
            }
        },

        /*
          Returns the user.
        */
        getUser( state ){
            return state.user;
        },
        allUsers (state) {
            return state.users
        },
        getShortAccessModules(){
            return ['dashboard', 'schedules-list', 'contract-edit', 'executions-list'];
        }
    }
};

export default user;
